import React, { Component } from 'react';
import {
  Modal,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';
import Loader from 'react-loader-spinner';

import { updtClientReceivingBank } from '../../../../helpers/api';

class ReceivingBankModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      receivingBank: null,
      error: null,
      pending: false,
    };
  }

  handleReceivingBank = (event) => {
    this.setState({ receivingBank: event.target.value });
  };

  updtReceivingBank = () => {
    if (!this.state.receivingBank)
      this.setState({ error: 'Invalid receivingBank!', pending: false });
    else {
      this.setState({ pending: true, error: null });
      this._asyncRequest = updtClientReceivingBank(
        this.props.publicKeyHash,
        this.state.receivingBank,
      )
        .then((res) => {
          if (res.status === 'SUCCESS') {
            this.props.loadClient();
            this.props.toggleReceivingBankModal();
          } else {
            this.setState({ error: res.error, pending: false });
          }
        })
        .catch((error) => {
          this.setState({ error: error.toString(), pending: false });
        });
    }
  };

  render() {
    return (
      <Modal
        size="md"
        isOpen={this.props.receivingBankModal}
        centered={true}
        backdrop="static"
        wrapClassName="modal-balance"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Update Receiving Bank Account
          </h5>
        </div>
        <div className="modal-body">
          {this.state.error && (
            <p className="text-danger">{this.state.error}</p>
          )}
          <FormGroup>
            <Label>ReceivingBank</Label>

            <Row>
              <Col sm="12">
                <InputGroup className="mb-2">
                  <InputGroupAddon addonType="prepend">
                    <span className="input-group-text">ReceivingBank</span>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    className="form-control"
                    onChange={this.handleReceivingBank}
                    autoComplete="off"
                  />
                </InputGroup>
              </Col>
            </Row>
          </FormGroup>
          {this.state.pending ? (
            <React.Fragment>
              <Loader type="Puff" color="#50a5f1" height={50} width={50} />
              <p className="mt-2 text-info">
                Notification sent onto your TrustBuilder Authenticator
                application.{' '}
                <strong>Set your pin code to update receiving account...</strong>
              </p>
            </React.Fragment>
          ) : (
            <Row className="mt-3">
              <Col sm="4">
                <button
                  className="btn btn-primary btn-block waves-effect waves-light"
                  type="submit"
                  onClick={() => this.props.toggleReceivingBankModal()}
                >
                  Close
                </button>
              </Col>
              <Col sm="6">
                <button
                  className="btn btn-warning btn-block waves-effect waves-light"
                  type="submit"
                  onClick={() => {
                    this.updtReceivingBank();
                  }}
                >
                  Update
                </button>
              </Col>
            </Row>
          )}
        </div>
      </Modal>
    );
  }
}

export default ReceivingBankModal;
